export default {
  nl: {
    footer: {
      title: 'Graag gedaan,',
      questions: 'Hoe kunnen we helpen?',
      otherQuestions: 'Andere vragen?',
      faq: 'Bekijk de veelgestelde vragen',
      businessReviews: '{{value, number(minimumFractionDigits: 0)}} Google Reviews',
      call: 'Bel met {{partner}}',
      sendEmail: 'Liever via de mail?',
      contactForm: 'Contactformulier',
      whiteLabelTerms: 'Vind [a="{{link}}"]hier[/a] de algemene voorwaarden van {{partner}}.',
      terms: 'Guidion handelt ter uitvoering van de overeenkomst van {{partner}} en is hierbij geen contractpartij. Vind [a="{{link}}"]hier[/a] de algemene voorwaarden van {{partner}}.',
      cookieStatement: 'Cookie verklaring',
    }
  },
  en: {
    footer: {
      title: 'Graag gedaan,',
      questions: 'How can we help you?',
      otherQuestions: 'Other questions?',
      faq: 'See the frequently asked questions',
      businessReviews: '{{value, number(minimumFractionDigits: 0)}} Google Reviews',
      call: 'Call {{partner}}',
      sendEmail: 'Prefer to send an email?',
      contactForm: 'Contact form',
      whiteLabelTerms: 'The general terms and conditions of {{partner}} can be found [a="{{link}}"]here[/a].',
      terms: 'Guidion only executes the agreement between you and {{partner}} and is not a contracting party to this. The general terms and conditions of {{partner}} can be found [a="{{link}}"]here[/a].',
      cookieStatement: 'Cookie statement',
    }
  }
};
